import { render, staticRenderFns } from "./correctAnswer.vue?vue&type=template&id=72cf8990&"
import script from "./correctAnswer.vue?vue&type=script&lang=js&"
export * from "./correctAnswer.vue?vue&type=script&lang=js&"
import style0 from "./correctAnswer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports